import { useCallback, useState } from 'react';
import { apiPost } from '../client';

export interface EmailSubscriptionData {
  email: string;
  type?: string;
  recaptcha?: string | null;
}

export interface EmailSubscriptionResponse {
  message: string;
  email: string;
}

export function useEmailSubscription() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const subscribe = useCallback(
    async (data: EmailSubscriptionData) => {
      setLoading(true);
      setError(null);
      setSuccess(false);

      try {
        const response = await apiPost<EmailSubscriptionResponse>(
          '/app/v1/email-subscription',
          data
        );

        setSuccess(true);
        return response;
      } catch (e: any) {
        const errorMessage = e?.message || 'Failed to subscribe. Please try again.';
        setError(errorMessage);
        throw new Error(errorMessage);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const resetState = useCallback(() => {
    setError(null);
    setSuccess(false);
  }, []);

  return { subscribe, loading, error, success, resetState };
}

